"use client";

import { Error } from "@/components";
import React from "react";

const NotFound = () => {
  return (
    <div className="min-h-screen flex justify-between items-center">
      <Error
        title="Page Not Found"
        description="The page you are looking for does not exist."
      />
    </div>
  );
};

export default NotFound;
